import script from "./RegistrationHabb.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationHabb.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__